export const ActionTypes = {
    SET_PROFILE_DATA:"SET_PROFILE_DATA",
    SET_LOGOUT:"SET_LOGOUT"
};